/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable prettier/prettier */
/** @jsx jsx */

import { Link } from 'gatsby';
import { Box, Flex, jsx, Container, Text, NavLink, Divider } from 'theme-ui';

import { BrandMark } from './Icon';
import ModeToggle from './ModeToggle';

// import { twitter, linkedin, facebook, github } from './svgData';

// const socialLinks = [
//   {
//     title: `Stay Connected`,
//     href: ``,
//   },
//   {
//     title: twitter,
//     href: `https://twitter.com/functionarylabs`,
//   },
//   {
//     title: linkedin,
//     href: `https://www.linkedin.com/company/functionary-labs/`,
//   },
//   {
//     title: facebook,
//     href: `https://facebook.com/functionaryco`,
//   },
//   {
//     title: github,
//     href: `https://github.com/functionaryco`,
//   },
// ]

const footerLink = [`Privacy`, `Contact us`];

const footerLinks = [
  [
    {
      title: `COMPANY`,
      href: ``,
    },
    {
      title: `About`,
      href: `/about`,
    },
    {
      title: `Case Studies`,
      href: `/case-studies`,
    },
    {
      title: `Careers`,
      href: `https://angel.co/company/functionary-labs/jobs`,
    },
    {
      title: `Service`,
      href: `/services`,
    },
  ],
  [
    {
      title: `SERVICES`,
      href: ``,
    },
    {
      title: `Privacy`,
      href: `/services/Privacy`,
    },
    {
      title: `Contact us`,
      href: `/contact`,
    },
    // {
    //   title: `Product Support`,
    //   href: `/services/support`,
    // },
    // {
    //   title: `Product Consulting`,
    //   href: `https://github.com/services/product-consulting`,
    // },
  ],
];

function Footer() {
  return (
    <Box
      as="footer"
      sx={{
        bg: `base`,
        // borderTop: `solid 1px`,
        borderColor: `grays.4`,
        py: [4, 4, 6],
      }}
    >
      <Divider
        color={`Dcolor`}
        sx={{
          maxWidth: [`90vw`, `80vw`, `85vw`],
          marginLeft: `auto`,
          marginRight: `auto`,
        }}
      />
      <Container sx={{ mt: [`3vh`, `10vh`, `10vh`] }}>
        <Box>
          <Flex
            variant="styles.gridly3"
            sx={{
              flexDirection: `column`,
              flex: 2,
              justifyContent: `space-between`,
              alignItems: `flex-start`,
            }}
          >
            <Flex
              sx={{
                minWidth: [`auto`, `auto`, `20ch`],
                maxWidth: `60ch`,
                pt: 0,
                marginRight: [`0px`, `0px`, `100px`],
                flexDirection: [`column`, `row`, `row`],
              }}
            >
              <Box
                sx={{
                  mr: [4, 0, 6],
                  color: `gray.5`,
                  svg: {
                    opacity: 1,
                    fill: `grays.5`,
                    path: { fill: `grays.6` },
                  },
                }}
              >
                <BrandMark />
              </Box>
              <Box sx={{ minWidth: `60%` }}>
                <Text
                  as="p"
                  sx={{
                    fontSize: 1,
                    pb: 2,
                    fontWeight: `heading`,
                    mb: [0, 3, 3],
                    mt: [3, 0, 0],
                    color: `Stext`,
                  }}
                >
                  hello@functionary.co
                </Text>
                <Text
                  as="p"
                  sx={{ color: `grays.7`, fontSize: 0, fontWeight: `heading` }}
                >
                  <Box
                    as="address"
                    sx={{
                      fontStyle: `normal`,
                      fontWeight: `body`,
                      fontSize: 0,
                      // textTransform: `uppercase`,
                      color: `Stext`,
                    }}
                  >
                    <Text
                      as="span"
                      sx={{ fontWeight: `heading`, mb: 2, mr: 2 }}
                    >
                      Bangalore ·
                    </Text>
                    {/* #24, Caravel Building, 1st A Main Road, ST Bed, Koramangala
                    4th Block, Bengaluru, Karnataka 560095 */}
                    <Text
                      as="span"
                      sx={{ fontWeight: `heading`, mb: 2, mr: 2 }}
                    >
                      Dubai ·
                    </Text>

                    <Text
                      as="span"
                      sx={{ fontWeight: `heading`, mb: 2, mr: 2 }}
                    >
                      Doha{` `}
                    </Text>
                  </Box>
                </Text>
                <Flex
                  sx={{
                    gap: [`12px`, `20px`, `20px`],
                    mt: [6],
                    alignItems: `center`,
                    '@media screen and (max-width: 720px)': {
                      display: `none`,
                    },
                  }}
                >
                  <Box
                    sx={{
                      '@media screen and (min-width: 900px)': {
                        display: `none`,
                      },
                    }}
                  >
                    <ModeToggle />
                  </Box>
                  <Text
                    as="p"
                    sx={{
                      // color: `grays.6`,
                      mt: 4,
                      color: `Stext`,
                      fontSize: 0,
                      fontWeight: `body`,
                      textAlign: `right`,
                    }}
                  >
                    © Functionary Labs Pvt Ltd 2022
                  </Text>
                </Flex>
              </Box>
            </Flex>

            <Flex
              sx={{
                flex: 1,
                maxWidth: [`100%`, `100%`, `100%`],
                flexDirection: [`column`, `row`, `row`],
              }}
            >
              {footerLinks &&
                footerLinks.map((f: any) => (
                  <Box
                    key={f[0].title}
                    sx={{
                      textAlign: `left`,
                      mx: [0, 5, 5],
                    }}
                  >
                    {f &&
                      f.map((fx: any) => (
                        <Box
                          key={fx.title}
                          // as="li"
                          sx={{
                            fontSize: 1,
                            listStyle: `none`,
                            my: 1,
                            mb: fx.href.length === 0 ? `16px` : `12px`,
                            marginTop: `0px`,
                            '@media screen and (max-width: 720px)': {
                              display: footerLink.includes(fx.title)
                                ? `none`
                                : ``,
                              mb: `20px`,
                            },
                          }}
                        >
                          {!fx.href && (
                            <Text
                              sx={{
                                color: `grays.6`,
                                fontSize: 0,
                                '@media screen and (max-width: 720px)': {
                                  display: `none`,
                                },
                              }}
                            >
                              {fx.title}
                            </Text>
                          )}

                          {fx.href && (
                            <NavLink as={Link} to={`${fx.href}`}>
                              <Text
                                sx={{
                                  fontSize: `18.75`,
                                  fontWeight: `500`,
                                  lineHeight: `26px`,
                                  '&:hover': { color: `hover` },
                                }}
                              >
                                {fx.title}
                              </Text>
                            </NavLink>
                          )}
                        </Box>
                      ))}
                  </Box>
                ))}
              <Flex
                sx={{
                  flexDirection: `column`,
                  marginRight: [`0px`, `0px`, `auto`],
                  marginLeft: `auto`,
                }}
              >
                <Text
                  sx={{
                    color: `grays.6`,
                    fontSize: 0,
                    mb: `16px`,
                    '@media screen and (max-width: 720px)': {
                      display: `none`,
                    },
                  }}
                >
                  STAY CONNECTED
                </Text>
                <Flex
                  sx={{
                    alignItems: `center`,
                    justifyContent: `center`,
                    gap: [`16px`, `10px`, `30px`],
                    mb: [`16px`, 0, 0],
                  }}
                >
                  <a href="https://twitter.com/functionarylabs">
                    {` `}
                    <svg
                      width="28"
                      height="22"
                      viewBox="0 0 28 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.6033 5.55834C24.6195 5.79343 24.6195 6.02852 24.6195 6.26577C24.6195 13.495 19.1161 21.8324 9.05287 21.8324V21.8281C6.08016 21.8324 3.16919 20.9809 0.666656 19.3754C1.09891 19.4274 1.53334 19.4534 1.96884 19.4545C4.43238 19.4566 6.8255 18.63 8.76361 17.1079C6.42249 17.0635 4.36955 15.5371 3.65237 13.3086C4.47246 13.4668 5.31748 13.4343 6.12241 13.2144C3.57003 12.6987 1.73376 10.4562 1.73376 7.85179C1.73376 7.82796 1.73376 7.80521 1.73376 7.78246C2.49427 8.20605 3.34578 8.44114 4.21679 8.46714C1.81284 6.86053 1.07183 3.66248 2.52352 1.16211C5.30123 4.58008 9.39954 6.65794 13.799 6.87786C13.3581 4.97767 13.9604 2.98647 15.3818 1.6507C17.5853 -0.420662 21.051 -0.314494 23.1223 1.88796C24.3476 1.64637 25.5219 1.19678 26.5966 0.559769C26.1882 1.8262 25.3334 2.90197 24.1916 3.58556C25.276 3.45773 26.3355 3.16739 27.3333 2.7243C26.5988 3.82498 25.6736 4.78375 24.6033 5.55834Z"
                        sx={{ fill: `white` }}
                      />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/company/functionary-labs/">
                    {` `}
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.0017 1.7647V22.2353C24.0017 22.7033 23.8158 23.1522 23.4848 23.4831C23.1539 23.8141 22.705 24 22.237 24H1.76641C1.29838 24 0.849525 23.8141 0.518579 23.4831C0.187633 23.1522 0.00170898 22.7033 0.00170898 22.2353L0.00170898 1.7647C0.00170898 1.29668 0.187633 0.847816 0.518579 0.51687C0.849525 0.185924 1.29838 0 1.76641 0L22.237 0C22.705 0 23.1539 0.185924 23.4848 0.51687C23.8158 0.847816 24.0017 1.29668 24.0017 1.7647ZM7.06053 9.17647H3.53112V20.4706H7.06053V9.17647ZM7.37817 5.29411C7.38003 5.02714 7.32929 4.76242 7.22884 4.51506C7.12839 4.2677 6.9802 4.04255 6.79274 3.85246C6.60527 3.66237 6.3822 3.51107 6.13626 3.40719C5.89032 3.30332 5.62632 3.2489 5.35935 3.24706H5.29582C4.75291 3.24706 4.23223 3.46273 3.84834 3.84663C3.46444 4.23052 3.24877 4.7512 3.24877 5.29411C3.24877 5.83703 3.46444 6.3577 3.84834 6.7416C4.23223 7.1255 4.75291 7.34117 5.29582 7.34117C5.56281 7.34774 5.82848 7.30164 6.07765 7.20549C6.32681 7.10935 6.55459 6.96506 6.74797 6.78086C6.94135 6.59665 7.09654 6.37615 7.20468 6.13195C7.31281 5.88775 7.37176 5.62464 7.37817 5.35764V5.29411ZM20.4723 13.6094C20.4723 10.2141 18.3123 8.89411 16.1664 8.89411C15.4638 8.85893 14.7642 9.00858 14.1375 9.32813C13.5108 9.64768 12.9788 10.126 12.5946 10.7153H12.4958V9.17647H9.17817V20.4706H12.7076V14.4635C12.6566 13.8483 12.8504 13.2378 13.2469 12.7646C13.6434 12.2915 14.2106 11.9939 14.8252 11.9365H14.9593C16.0817 11.9365 16.9146 12.6423 16.9146 14.4212V20.4706H20.444L20.4723 13.6094Z"
                        sx={{ fill: `white` }}
                      />
                    </svg>
                  </a>
                  <a href="https://twitter.com/functionarylabs">
                    {` `}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M27.3322 14.0822C27.3322 6.6733 21.3633 0.667969 13.9989 0.667969C6.63441 0.667969 0.665527 6.6733 0.665527 14.0822C0.665527 20.7791 5.54019 26.3284 11.9153 27.3346V17.9604H8.53041V14.0813H11.9153V11.1266C11.9153 7.76485 13.9055 5.90708 16.9517 5.90708C18.4095 5.90708 19.9366 6.1693 19.9366 6.1693V9.47063H18.254C16.598 9.47063 16.0824 10.5053 16.0824 11.5666V14.0822H19.7802L19.1891 17.9595H16.0824V27.3346C22.4575 26.3284 27.3322 20.7791 27.3322 14.0822Z"
                        sx={{ fill: `white` }}
                      />
                    </svg>
                  </a>
                  <a href="https://github.com/functionaryco">
                    {` `}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.0001 0.996094C6.63341 0.996094 0.666748 6.96276 0.666748 14.3294C0.666748 20.2294 4.48341 25.2127 9.78341 26.9794C10.4501 27.0961 10.7001 26.6961 10.7001 26.3461C10.7001 26.0294 10.6834 24.9794 10.6834 23.8627C7.33341 24.4794 6.46674 23.0461 6.20008 22.2961C6.05008 21.9127 5.40008 20.7294 4.83341 20.4127C4.36675 20.1627 3.70008 19.5461 4.81675 19.5294C5.86674 19.5127 6.61674 20.4961 6.86674 20.8961C8.06674 22.9127 9.98341 22.3461 10.7501 21.9961C10.8667 21.1294 11.2167 20.5461 11.6001 20.2127C8.63341 19.8794 5.53341 18.7294 5.53341 13.6294C5.53341 12.1794 6.05008 10.9794 6.90008 10.0461C6.76674 9.71276 6.30008 8.34609 7.03341 6.51276C7.03341 6.51276 8.15008 6.16276 10.7001 7.87942C11.7667 7.57942 12.9001 7.42942 14.0334 7.42942C15.1667 7.42942 16.3001 7.57942 17.3667 7.87942C19.9167 6.14609 21.0334 6.51276 21.0334 6.51276C21.7667 8.34609 21.3001 9.71276 21.1667 10.0461C22.0167 10.9794 22.5334 12.1628 22.5334 13.6294C22.5334 18.7461 19.4167 19.8794 16.4501 20.2127C16.9334 20.6294 17.3501 21.4294 17.3501 22.6794C17.3501 24.4627 17.3334 25.8961 17.3334 26.3461C17.3334 26.6961 17.5834 27.1127 18.2501 26.9794C20.897 26.0858 23.197 24.3847 24.8265 22.1155C26.4559 19.8462 27.3327 17.1231 27.3334 14.3294C27.3334 6.96276 21.3667 0.996094 14.0001 0.996094Z"
                        sx={{ fill: `white` }}
                      />
                    </svg>
                  </a>
                </Flex>
              </Flex>
              <Box
                sx={{
                  // marginRight: `10px`,
                  '@media screen and (max-width: 900px)': {
                    display: `none`,
                  },
                }}
              >
                <ModeToggle />
              </Box>
            </Flex>
            <Flex
              sx={{
                gap: [`12px`, `20px`, `20px`],
                alignItems: `center`,
                '@media screen and (min-width: 720px)': {
                  display: `none`,
                },
              }}
            >
              <Box
                sx={{
                  '@media screen and (min-width: 720px)': {
                    display: `none`,
                  },
                }}
              >
                <ModeToggle />
              </Box>
              <Text
                as="p"
                sx={{
                  // color: `grays.6`,
                  color: `Stext`,
                  fontSize: 0,
                  fontWeight: `body`,
                  textAlign: `right`,
                }}
              >
                © Functionary Labs Pvt Ltd 2022
              </Text>
            </Flex>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
}
export default Footer;
